import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { WorkplaceInfo } from '../../../api';
import LabelAndTextBox from '../../molecules/labelandtextbox/LabelAndTextBox';
import './WorkplaceInfo.css';

interface WorkplaceInfoProp {
    workplaceInfo: WorkplaceInfo;
}

const WorkplaceInfosection: React.FC<WorkplaceInfoProp> = (props) => {

    return (
        <Container className='align-items-center tablecolor'>
            <Row>
                <Col xs={12} md={6} lg={12}>
                    <div className='header-section-input mb-3'>
                        <h3>2. Uppgifter om platsen där ställningen/väderskyddet ska användas</h3>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <LabelAndTextBox title='Kommun och fastighetsbeteckning' remark={props.workplaceInfo?.workplaceCity}
                        onChange={(value) => props.workplaceInfo.workplaceCity = value} />
                </Col>
                <Col xs={12}>
                    <LabelAndTextBox title='Arbetsplatsens adress' remark={props.workplaceInfo?.workplaceAddress}
                        onChange={(value) => props.workplaceInfo.workplaceAddress = value} />
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={6} lg={12}>
                    <div className='header-section-2'>
                        <p>Övriga uppgifter(t.ex. vilken byggnad, lokal e.dyl.)</p>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={6} lg={12}>
                    <div className='checkboxes1'>
                        <input type="checkbox" defaultChecked={props.workplaceInfo?.indoors}
                            onChange={() => {
                                if (props.workplaceInfo.indoors === false) {
                                    props.workplaceInfo.indoors = true;
                                }
                                else if (props.workplaceInfo.indoors === true) {
                                    props.workplaceInfo.indoors = false;
                                }
                            }} />
                        <label>Inomhus</label>
                        <br />
                        <input type="checkbox" defaultChecked={props.workplaceInfo?.outdoors}
                            onChange={() => {
                                if (props.workplaceInfo.outdoors === false) {
                                    props.workplaceInfo.outdoors = true;
                                }
                                else if (props.workplaceInfo.outdoors === true) {
                                    props.workplaceInfo.outdoors = false;
                                }
                            }} />
                        <label>Utomhus</label>
                        <br />
                        <input type="checkbox" defaultChecked={props.workplaceInfo?.scaffoldWillBeClosedOffToTraffic}
                            onChange={() => {
                                if (props.workplaceInfo.scaffoldWillBeClosedOffToTraffic === false) {
                                    props.workplaceInfo.scaffoldWillBeClosedOffToTraffic = true;
                                }
                                else if (props.workplaceInfo.scaffoldWillBeClosedOffToTraffic === true) {
                                    props.workplaceInfo.scaffoldWillBeClosedOffToTraffic = false;
                                }
                            }} />
                        <label>Ställningen kommer att <br />spärras av mot trafik</label>
                    </div>
                </Col>
            </Row>
            <hr />
        </Container>
    );
};

export default WorkplaceInfosection;